import React, { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import LoadingScreen from '../components/LoadingScreen'
import Home from '@/pages/Home'

const About = lazy(() => import('@/pages/About'))
const Service = lazy(() => import('@/pages/Service'))
const Resume = lazy(() => import('@/pages/Resume'))
const Contact = lazy(() => import('@/pages/Contact'))
const Tools = lazy(() => import('@/pages/Tools'))
const PageTransition = lazy(() => import('../components/PageTransition'))
const ErrorBlock = lazy(() => import('../components/ErrorBlock'))

const withPage = (
  element: React.ReactNode,
  message: string,
  eager = false
) =>
  eager ? (
    element
  ) : (
    <Suspense fallback={<LoadingScreen message={message} />}>
      <PageTransition>{element}</PageTransition>
    </Suspense>
  )

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={withPage(<Home />, 'Loading Home...', true)} />
      <Route
        path="/home"
        element={withPage(<Home />, 'Loading Home...', true)}
      />
      <Route path="/about" element={withPage(<About />, 'Loading About...')} />
      <Route
        path="/service"
        element={withPage(<Service />, 'Loading Services...')}
      />
      <Route
        path="/resume"
        element={withPage(<Resume />, 'Loading Resume...')}
      />
      <Route
        path="/contact"
        element={withPage(<Contact />, 'Loading Contact...')}
      />
      <Route path="/tools" element={withPage(<Tools />, 'Loading Tools...')} />
      <Route
        path="*"
        element={
          <Suspense fallback={<LoadingScreen message="Loading..." />}>
            <ErrorBlock variant="404" />
          </Suspense>
        }
      />
    </Routes>
  )
}

export default Routing
